var _style, _circle, _path, _circle2, _path2, _path3, _g, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#21A365;}\n\t.st1{fill:#107C41;}\n\t.st2{fill:#185B37;}\n\t.st3{fill:#33C481;}\n\t.st4{fill:#17864C;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#036C70;}\n\t.st7{fill:#1A9BA1;}\n\t.st8{fill:#37C6D0;}\n\t.st9{fill:#04878B;}\n\t.st10{fill:#4F59CA;}\n\t.st11{fill:#7B82EA;}\n\t.st12{fill:#4C53BB;}\n\t.st13{fill:#0F78D5;}\n\t.st14{fill:#29A7EB;}\n\t.st15{fill:#0358A8;}\n\t.st16{fill:#0F79D6;}\n\t.st17{fill:#038387;}\n\t.st18{fill:#048A8E;}\n\t.st19{fill:#C8421D;}\n\t.st20{fill:#FF8F6A;}\n\t.st21{fill:#ED6B47;}\n\t.st22{fill:#891323;}\n\t.st23{fill:#AF2131;}\n\t.st24{fill:#C94E60;}\n\t.st25{fill:#E08195;}\n\t.st26{fill:#B42839;}\n\t.st27{fill:#0464B8;}\n\t.st28{fill:#0377D4;}\n\t.st29{fill:#4FD8FF;}\n\t.st30{fill:#1681D7;}\n\t.st31{fill:#0178D4;}\n\t.st32{fill:#042071;}\n\t.st33{fill:#168FDE;}\n\t.st34{fill:#CA64EA;}\n\t.st35{fill:#7E1FAF;}\n\t.st36{fill:#AE4BD5;}\n\t.st37{fill:#9332BF;}\n\t.st38{fill:#7719AA;}\n\t.st39{fill:#0078D4;}\n\t.st40{fill:#1490DF;}\n\t.st41{fill:#0364B8;}\n\t.st42{fill:#28A8EA;}\n\t.st43{fill:#41A5ED;}\n\t.st44{fill:#2C7BD5;}\n\t.st45{fill:#195ABE;}\n\t.st46{fill:#103E91;}\n\t.st47{fill:#2166C3;}\n\t.st48{opacity:0.2;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.1,
    cy: 30.2,
    r: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M108.3,104.8h-2c-10.7,0-19.3-8.7-19.3-19.3V54.9c0-3.1,2.5-5.5,5.5-5.5h29.6c3.1,0,5.5,2.5,5.5,5.5v30.5  C127.7,96.1,119,104.8,108.3,104.8z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 70.3,
    cy: 24.2,
    r: 18.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M70.4,122.1h-3.2c-16.8,0-30.5-13.7-30.5-30.5V54.1c0-2.5,2.1-4.6,4.6-4.6h55c2.5,0,4.6,2.1,4.6,4.6v37.5  C100.9,108.4,87.3,122.1,70.4,122.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M59.5,97.2h-53c-3.5,0-6.4-2.9-6.4-6.4V38.6c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.9,94.3,63.1,97.2,59.5,97.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.4,52.7H19v-5.5h27.5v5.5H36.1V83h-6.6V52.7z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M66,49.5v41.2c0,3.5-2.9,6.4-6.4,6.4H37.2l1.5,5.7H65c3.5,0,6.4-2.9,6.4-6.4V49.5L66,49.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsIcon);
export default __webpack_public_path__ + "static/media/teamsIcon.aaa0f4c2d7f9ef5833ea1c3c312d5f44.svg";
export { ForwardRef as ReactComponent };